import React, { useEffect, useState } from "react";
import { styles } from "./Styles";
import { Logo } from "../utils/constants/Icons.constants";
import { Constants } from "../utils/constants/Constants";
import {
  Avatar,
  Box,
  IconButton,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";
import { logout } from "../helpers/authhelper";
import { useNavigate } from "react-router-dom";
import { SnackBar } from "../components/snackbar/SnackBar";
import { RoutesPath } from "../routes/route-path";
const Navbar = () => {
  const classes = styles;
  const router = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openError, setOpenError] = useState(false);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCloseError = (event, reason) => {
    if (reason === Constants.EVENT_CLICKAWAY) {
      return;
    }
    setOpenError(false);
  };

  const adminUser = JSON.parse(
    localStorage.getItem(`${Constants.LOCAL_STORAGE_KEY_ADMIN_USER}`)
  );

  const handleLogout = () => {
    logout(() => {
      router(RoutesPath.LOGIN);
    });
  };

  return (
    <div style={classes.navbar}>
      <SnackBar
        openError={openError}
        message={Constants.SESSION_MESSAGE}
        handleClose={handleCloseError}
      />
      <Logo route={{ router }} styles={classes.pointer} />

      <Box sx={classes.profileBox}>
        <IconButton
          id="basic-button"
          aria-controls={open ? "basic-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClick}
          size="medium"
        >
          <Avatar
            sx={classes.pointerAvatar}
            alt=""
            src={adminUser?.image_url}
          />
        </IconButton>
        <Box
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <Typography
            fontSize={Constants.FONT_SIZE_LARGE}
            color="#000000"
            sx={classes.boldMY4}
          >
            {adminUser?.full_name}{" "}
          </Typography>
          <Typography
            fontSize={Constants.FONT_SIZE_LARGE}
            color="#656565"
            sx={classes.boldMY3}
          >
            {adminUser?.email}
          </Typography>
        </Box>
      </Box>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuItem onClick={handleLogout}>{Constants.TEXT_LOGOUT}</MenuItem>
      </Menu>
    </div>
  );
};

export default Navbar;
